/**
 * Desktop accordion synced to <product-carousel> for banner 6.
 */
if (!customElements.get('two-toaster-ver2-banner6')) {
  class TwoToasterVer2Banner6 extends HTMLElement {
    /** @type {NodeListOf<HTMLElement> | null} */
    _groups = null;
    /** @type {HTMLElement | null} */
    _carousel = null;
    /** @type {number} */
    _tries = 0;

    /** @type {boolean} */
    _swiperBound = false;

    /** @type {SwiperInstance | null} */
    _boundSwiper = null;

    /** @type {number | null} */
    _waitRafId = null;

    /** @type {number | null} */
    _waitTimeoutId = null;

    connectedCallback() {
      this._groups = this.querySelectorAll('.collapse-accordion__group');
      this._carousel = this.querySelector('product-carousel');

      this._onGroupClick = this._onGroupClick.bind(this);
      this._onSlideChange = this._onSlideChange.bind(this);
      this._onResize = this._onResize.bind(this);

      this._groups.forEach((group) => {
        group.addEventListener('click', this._onGroupClick);
      });
      window.addEventListener('resize', this._onResize, { passive: true });

      this._tries = 0;
      this._activateAccordion(0);
      this._waitForSwiper();
    }

    disconnectedCallback() {
      this._clearSwiperWait();
      this._groups?.forEach((group) => {
        group.removeEventListener('click', this._onGroupClick);
      });
      window.removeEventListener('resize', this._onResize);
      this._detachSwiperListener();
      this._tries = 0;
    }

    _clearSwiperWait() {
      if (this._waitRafId != null) {
        cancelAnimationFrame(this._waitRafId);
        this._waitRafId = null;
      }
      if (this._waitTimeoutId != null) {
        clearTimeout(this._waitTimeoutId);
        this._waitTimeoutId = null;
      }
    }

    _detachSwiperListener() {
      this._boundSwiper?.off?.('slideChange', this._onSlideChange);
      this._boundSwiper = null;
      this._swiperBound = false;
    }

    _bindSwiperListener(swiper) {
      if (this._swiperBound && this._boundSwiper === swiper) return;

      this._boundSwiper?.off?.('slideChange', this._onSlideChange);
      swiper.off?.('slideChange', this._onSlideChange);
      swiper.on('slideChange', this._onSlideChange);
      this._boundSwiper = swiper;
      this._swiperBound = true;
    }

    _waitForSwiper() {
      const swiper = this._carousel?.swiper;
      if (swiper) {
        this._clearSwiperWait();
        this._bindSwiperListener(swiper);
        this._activateAccordion(swiper.activeIndex);
        return;
      }

      this._tries += 1;
      if (this._tries > 80) return;
      if (this._tries < 10) {
        this._waitRafId = requestAnimationFrame(() => {
          this._waitRafId = null;
          this._waitForSwiper();
        });
      } else {
        this._waitTimeoutId = window.setTimeout(() => {
          this._waitTimeoutId = null;
          this._waitForSwiper();
        }, 25);
      }
    }

    _onGroupClick(event) {
      const group = event.currentTarget;
      const index = Array.prototype.indexOf.call(this._groups, group);
      if (index < 0) return;
      this._activateAccordion(index);
      this._carousel?.swiper?.slideTo(index);
    }

    _onSlideChange() {
      const index = this._carousel?.swiper?.activeIndex;
      if (index == null) return;
      this._activateAccordion(index);
    }

    _onResize() {
      const active = this.querySelector('.collapse-accordion__group.active');
      const panel = active?.querySelector('.label');
      if (!panel || panel.style.maxHeight === '0px') return;
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    }

    _activateAccordion(index) {
      this._groups?.forEach((group, i) => {
        const panel = group.querySelector('.label');
        const active = i === index;
        group.classList.toggle('active', active);
        if (!panel) return;
        panel.style.maxHeight = active ? `${panel.scrollHeight}px` : '0px';
      });
    }
  }

  customElements.define('two-toaster-ver2-banner6', TwoToasterVer2Banner6);
}
